import { Action } from '@ngrx/store';
import { BreadcrumbObject } from '@shared/store/router/reducers/router-breadcrumbs.reducers';

export const ROUTER_UPDATE_BREADCRUMBS = '[Router] Update breadcrumbs';

export class RouterUpdateBreadcrumbs implements Action {
  readonly type = ROUTER_UPDATE_BREADCRUMBS;
  constructor(public payload: BreadcrumbObject[]) {}
}

export type RouterBreadcrumbsActions = RouterUpdateBreadcrumbs;
